function closeMobileMenuOnEscape(event) {
  if (event.key !== 'Escape') return;

  const drawer = document.querySelector('.header-drawer--mobile');
  const drawerDetails = drawer?.querySelector('#Details-menu-drawer-container');
  if (!drawerDetails?.classList.contains('menu-open')) return;

  const closeButton = drawerDetails.querySelector(
    '.sollie-mobile-menu__masthead button[aria-label]'
  );
  const menuTrigger = drawerDetails.querySelector(':scope > .header__icon--summary');
  if (!(closeButton instanceof HTMLButtonElement)) return;

  event.preventDefault();
  closeButton.click();
  window.setTimeout(() => {
    if (menuTrigger instanceof HTMLElement) menuTrigger.focus({ preventScroll: true });
  }, 420);
}

if (!window.sollieMobileMenuReady) {
  window.sollieMobileMenuReady = true;
  document.addEventListener('keydown', closeMobileMenuOnEscape);
}
